import Fetcher from './Fetcher';

// TODO qui farò i vari check di error per ritornare
// diversi testi per l'utente.
// per ora ritorno l'errore puro.
// le funzioni sono volutamente tenute separate per gestire errori diversi in futuro.

/** 2026 :: WORKING :)
 * returns price data from api.
 * no params needed
 * */
export async function get_feed_state (  )
{
  return new Promise(( resolve, reject ) => {
    Fetcher( { op : 'get_feed_state' }, 'nfeed' ).then( re => {
      resolve( re );
    }).catch( err => {
      reject( err );
    });
  });
}

/** 2026 :: WORKING :)
 * returns product data from api.
 * no params needed
 * */
export async function get_product_state (  )
{
  return new Promise(( resolve, reject ) => {
    Fetcher({ op : 'get_product_state' }, 'nfeed' ).then( re => {
      resolve( re );
    }).catch( err => {
      reject( err );
    });
  });
}

/** 2026 :: WORKING WIP :)
 * returns pac settings data from api.
 * no params needed
 * */
export async function get_pac_settings (  )
{
  return new Promise(( resolve, reject ) => {
    Fetcher({ op : 'get_pac_settings' }, 'nfeed' ).then( re => {
      resolve( re );
    }).catch( err => {
      reject( err );
    });
  });
}
